interface AdBannerBrandProducts {
  id: number;
  name: string;
  products: {
    display: string;
    value: number;
  }[];
}

interface AdBannerMedia {
  file: string;
  id: string;
  type: string;
  url: string;
}

export interface AdBanner {
  id: string;
  allBrands: boolean;
  brandProducts: AdBannerBrandProducts[];
  buttonText: string;
  description: string;
  folder: string;
  lCover: AdBannerMedia;
  mCover: AdBannerMedia;
  sCover: AdBannerMedia;
  media: AdBannerMedia[];
  name: string;
  position: string;
  published: boolean;
  redirectLinkActive: boolean;
  redirectLink: string;
  url: string;
  mainImageIndex: number;
  searchJson: Array<any>;
  productIds: { id: number; name: string }[];
}

export class TrackingEvent {
  id: string = '';
  sessionId: string = '';
  userId: string = '';
  customerId: number = 0;
  adBannerId: string = '';
  duration: number = 0;
  openTimeStamp: string = new Date().toISOString();
  closeTimeStamp: string = new Date().toISOString();
  closedBy?: 'CLOSE_BUTTON' | 'FILTER_BUTTON';
  productIds: number[] = [];
  cartId: number = 0;
}
